import { Inject } from '@odinjs/odin';
import { PanelAPI, PDFViewerAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import { FragmentNames, MyChartViewSentDocumentAliases } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.MY_CHART_VIEW_SENT_DOCUMENT })
export default class MyChartSendingDocumentsController extends BaseController {

  @Inject(MyChartViewSentDocumentAliases.PDF_VIEWER)
    pdfViewerAPI!: PDFViewerAPI;

  @Inject(MyChartViewSentDocumentAliases.PANEL_LOADER)
    panelLoaderAPI!: PanelAPI;

  @OnMount(MyChartViewSentDocumentAliases.LAYOUT_VIEW_SENT_DOCUMENT)
  handleLayoutViewSentDocumentLoading(): void {
    const filePath = this.context.get('filePath');

    this.panelLoaderAPI.setVisible(false);
    this.pdfViewerAPI.setVisible(true);

    const srcPath = resolvePath(`${APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: filePath })
    this.pdfViewerAPI.setSrc(srcPath);
  }
}
